import { DatoCmsPdv } from 'lib/datoCms/queries/getAllPdvLabels';
import { DatoCmsSignUp } from 'lib/datoCms/queries/getAllSignUpLabels';
import { DatoSignUpErrorsLabels } from 'lib/types/signup-errors-label';
import { AccountDataLabel } from '../../accountData/AccountData';
import { LabelAccessData } from '../accessData';

export const getLabelAccessData = (labels: (DatoCmsSignUp | DatoCmsPdv) & DatoSignUpErrorsLabels): LabelAccessData => {
  return {
    titleAccessData: labels.titleFirstForm,
    descriptionAccessData: labels.descriptionFirstForm,
    titleProtectAccount: labels.titleSecondForm,
    descriptionProtectAccount: labels.descriptionSecondForm,
    username: labels.username,
    placeholderUsername: labels.placeholderUsername,
    password: labels.password,
    repeatPassword: labels.repeatPassword,
    placeholderPassword: labels.placeholderPassword,
    secretQuestion: labels.secretQuestion,
    question: labels.question,
    answer: labels.answer,
    placeholderAnswer: labels.placeholderAnswer,
    genericError: labels.genericError,
    passwordMismatch: labels.passwordMismatch,
    usernameNotValid: labels.usernameNotValid,
    usernameExist: labels.usernameExist,
    labelUsernameRules: labels.labelUsernameRules,
  };
};

export const getLabelForAccountData = (labels: DatoCmsSignUp): AccountDataLabel => {
  return {
    labelName: labels.name,
    labelSurname: labels.surname,
    labelFiscalCode: labels.fiscalCode,
    labelEmail: labels.email,
    labelTelephone: labels.telephone,
    labelAddress: labels.address,
    labelProvince: labels.county,
    labelCity: labels.city,
    labelZipCode: labels.zipCode,
  };
};
